module.exports = __webpack_public_path__ + "static/media/waiting.ac289b6e.svg";